// extracted by mini-css-extract-plugin
module.exports = {"Pagen":"pagenOld_Pagen__ZbpUo","Current":"pagenOld_Current__yy2z6","ShowMore":"pagenOld_ShowMore__Yg1Qa","Buttom":"pagenOld_Buttom__ohL8E"};